import { useMemo } from 'react';
import { useGetConversationsQuery } from '@/store/api';

/**
 * Hook to get the total unread marketplace conversations count.
 * Uses polling to keep the count updated.
 * 
 * Can be extended to include property chat unread count if that data becomes available.
 */
export const useUnreadConversationsCount = () => {
  // Fetch marketplace conversations with polling
  const { 
    data: marketplaceConversations = [], 
    isLoading: isLoadingMarketplace,
  } = useGetConversationsQuery(undefined, {
    pollingInterval: 30000, // Poll every 30 seconds for unread updates
  });

  // Calculate marketplace unread count
  const marketplaceUnreadCount = useMemo(() => {
    return marketplaceConversations.filter(c => c.isUnread).length;
  }, [marketplaceConversations]);

  // For now, we only track marketplace unread count
  // Property chat unread tracking would need to be added when the API supports it
  const totalUnreadCount = marketplaceUnreadCount;

  return {
    unreadCount: totalUnreadCount,
    marketplaceUnreadCount,
    isLoading: isLoadingMarketplace,
  };
};

export default useUnreadConversationsCount;
